export default __webpack_public_path__ + "static/media/message.f87982f1.svg";